import { render, staticRenderFns } from "./ZdmEditorFeatureDialog.vue?vue&type=template&id=3b9dcf67&"
import script from "./ZdmEditorFeatureDialog.vue?vue&type=script&lang=js&"
export * from "./ZdmEditorFeatureDialog.vue?vue&type=script&lang=js&"
import style0 from "./ZdmEditorFeatureDialog.vue?vue&type=style&index=0&id=3b9dcf67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports